// @flow
import {
  requestBrandEngageSearchResults,
  receiveBrandEngageSearchResults,
  requestBrandEngageAddResponse,
  receiveBrandEngageAddResponse,
  requestBrandEngageDismissContent,
  receiveBrandEngageDismissContent,
  removeDismissedItem,
} from './brandEngageActions';
import { type ActionType, handleActions } from 'redux-actions';
import { Map, Set } from 'immutable';
import { Observation } from 'models';

export type BrandEngageState = {
  requestStatus: ?RequestStatus,
  data: Map<Id, *>,
  ugcIds: ?GetContentResponse,
  responseRequestStatus: Map<Id, ?RequestStatus>,
  dismissRequestStatus: Map<Id, ?RequestStatus>,
  dismissedUgcIds: Set<Id>,
};

export const defaultState: BrandEngageState = {
  requestStatus: null,
  data: Map(),
  ugcIds: [],
  responseRequestStatus: Map(),
  dismissRequestStatus: Map(),
  dismissedUgcIds: Set(),
};

export default handleActions(
  {
    [requestBrandEngageSearchResults.toString()]: (
      state: BrandEngageState,
      action: ActionType<typeof requestBrandEngageSearchResults>
    ) => {
      return {
        ...state,
        requestStatus: 'pending',
      };
    },

    [receiveBrandEngageSearchResults.toString()]: (
      state: BrandEngageState,
      action: ActionType<typeof receiveBrandEngageSearchResults>
    ) => {
      const { error, payload } = action;
      if (error === true) {
        return {
          ...state,
          requestStatus: payload,
        };
      }
      return {
        ...state,
        requestStatus: 'complete',
        data: payload[1],
        ugcIds: payload[0],
      };
    },

    [requestBrandEngageAddResponse.toString()]: (
      state: BrandEngageState,
      action: ActionType<typeof requestBrandEngageAddResponse>
    ) => {
      const { meta: parentUgcId } = action;
      return {
        ...state,
        responseRequestStatus: state.responseRequestStatus.set(
          parentUgcId,
          'pending'
        ),
      };
    },

    [receiveBrandEngageAddResponse.toString()]: (
      state: BrandEngageState,
      action: ActionType<typeof receiveBrandEngageAddResponse>
    ) => {
      if (action.error) {
        return {
          ...state,
          responseRequestStatus: state.responseRequestStatus.set(
            action.meta,
            action.payload
          ),
        };
      }
      const { meta: parentUgcId, payload: childUgc } = action;
      const { ugc, ...rest } = state.data.get(parentUgcId);
      const updatedUgc = ugc.update('ugc_related_content', l =>
        l.push(childUgc)
      );
      return {
        ...state,
        responseRequestStatus: state.responseRequestStatus.set(
          parentUgcId,
          'complete'
        ),
        data: state.data.set(parentUgcId, { ...rest, ugc: updatedUgc }),
      };
    },

    [requestBrandEngageDismissContent.toString()]: (
      state: BrandEngageState,
      action: ActionType<typeof requestBrandEngageDismissContent>
    ) => {
      const { meta: ugc_id } = action;
      return {
        ...state,
        dismissRequestStatus: state.dismissRequestStatus.set(ugc_id, 'pending'),
      };
    },

    [receiveBrandEngageDismissContent.toString()]: (
      state: BrandEngageState,
      action: ActionType<typeof receiveBrandEngageDismissContent>
    ) => {
      const { meta: ugc_id, error } = action;

      if (error === true) {
        return {
          ...state,
          dismissRequestStatus: state.dismissRequestStatus.set(
            ugc_id,
            action.payload
          ),
        };
      }

      const {
        observations: prevObservations,
        ...otherDataItems
      } = state.data.get(ugc_id);
      const observations = prevObservations
        ? prevObservations.add(Observation.BrandEngaged)
        : Set([Observation.BrandEngaged]);

      return {
        ...state,
        data: state.data.set(ugc_id, {
          ...otherDataItems,
          observations,
        }),
        dismissRequestStatus: state.dismissRequestStatus.remove(ugc_id),
        dismissedUgcIds: state.dismissedUgcIds.add(ugc_id),
      };
    },

    [removeDismissedItem.toString()]: (
      state: BrandEngageState,
      action: ActionType<typeof removeDismissedItem>
    ) => {
      const { payload: ugc_id } = action;

      return {
        ...state,
        data: state.data.remove(ugc_id),
        dismissedUgcIds: state.dismissedUgcIds.remove(ugc_id),
      };
    },
  },
  defaultState
);



// WEBPACK FOOTER //
// ./src/containers/brand-engage/brandEngageReducer.js